import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { TickCircle } from "iconsax-react";

import { AuthEntryCard } from "@/features/auth/components/AuthEntryCard";
import { Button } from "@/shared/components/ui/Button";
import { resetRegistration } from "@/features/auth/store/registration.store";

export function AuthRegisterSuccessPage() {
  const navigate = useNavigate();
  const { t } = useTranslation("register");

  useEffect(() => {
    resetRegistration();
  }, []);

  return (
    <AuthEntryCard
      variant="success"
      cardClassName="
        !w-full !max-w-[43rem] !min-h-[min(45rem,calc(100svh-6rem))] !rounded-sm
        !px-12 !pt-10 !pb-9
        max-md:!px-8 max-md:!pt-10 max-md:!pb-8
        max-[40rem]:!min-h-svh max-[40rem]:!rounded-none max-[40rem]:!px-5 max-[40rem]:!pt-8 max-[40rem]:!pb-6
      "
      contentClassName=" !flex !w-full !flex-1 !flex-col !items-center !justify-center !text-center"
    >
      <div
        className="
          !mt-20 !inline-flex !h-[3.25rem] !w-[3.25rem] !items-center !justify-center
          !text-[#22c266]
          max-[40rem]:!mt-20
        "
        aria-hidden="true"
      >
        <TickCircle size={60} variant="Linear" color="currentColor" />
      </div>

      <h1 className=" !mt-7 !text-[2rem] !leading-[1.1] !font-bold !text-text-primary">
        {t("register:success.title")}
      </h1>
      <p className=" !mx-auto !mt-4 !w-full !max-w-[28rem] !text-[1rem] !leading-[1.4] !font-normal !text-[#373d45]">
        {t("register:success.description")}
      </p>

      <div className="!mt-40 !w-full">
        <Button
          className="!min-h-12 !text-base !font-normal !bg-[#1B6CA7] !border-[#1B6CA7] hover:!bg-[#1B6CA7] hover:!border-[#1B6CA7] active:!bg-[#1B6CA7] active:!border-[#1B6CA7]"
          onClick={() => navigate("/login")}
        >
          {t("register:success.btn.login")}
        </Button>
      </div>
    </AuthEntryCard>
  );
}
